export  const setCounter = (imageData) => `(${imageData.length} ${imageData.length === 1 ? 'item' : 'items'})`;